import { useState } from "react"
import { useApolloClient } from "@apollo/react-hooks"

import { useTranslation } from "lib/i18n/translation"
import { useAccesses } from "lib/accesses"

import moment from "moment"
import { useModal } from "lib/modal"

const ConfirmTerminateMissYou = () => {
	const { c } = useTranslation("common")
	const { hide } = useModal()

	return (
		<>
			<h2 className="main-title">{c("we-will-miss-you")}</h2>
			<figure class="cover">
				<picture>
					<img src="https://atelier-hybrid.com/pro/lacinetek/shared/svod/svod-focus-06.jpg" height="575" width="1600" alt="Titre du film"/>
				</picture>
			</figure>
			<div className="overlay-footer fixed">
				<nav className="buttons centered short">
					<a
						href="#"
						onClick={async (e) => {
							e.preventDefault();
							hide()
						}}
						rel="nofollow noopener"
						title={c("close")}
						className="close"
						>
						{c("close")}
					</a>
				</nav>
			</div>
		</>
	)
}

export default ConfirmTerminateMissYou
